import "./mainbanner.scss"
import { Box, Grid, Button, CircularProgress, Typography, Skeleton, IconButton, Tooltip } from "@mui/material";

import ampPic from "../../../static/images/distant_amp/fleshweaver.webp"
import bg_image from "../../../static/images/distant_amp/bg_desktop.mp4"
import ampvid from "../../../static/images/distant_amp/background.MP4"
import ampvidMobile from "../../../static/images/distant_amp/bg_desktop.mp4"
import thumbnail from "../../../static/images/cn_amp/eco_thumbnail.webp"
import thumbnailMobile from "../../../static/images/cn_amp/eco_thumbnail_mobile.webp"

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



import { useEffect, useState } from "react";
import BuyButton from "../../BuyButton";
import PriceComponent from "../../PriceComponents";

const Image = () => {
  return <img loading="lazy" alt="Guitar Amplifier" src={ampPic} width="100%" style={{ maxWidth: "800px" }}></img>
}

const MainBanner = ({ price, product, onTrial }) => {

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  const [animationDone, setAnimationDone] = useState(true);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < window.innerHeight
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  return (
    <Box
      sx={{
        backgroundSize: "cover",
        position: "relative",
        p: 0,
        m: 0,
        flex: 100,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: { xs: "block", md: "flex" },
        flexDirection: "column",
        minHeight: "100vh",
        // maxHeight: "calc(100vh)",
      }}
    >
      <video style={{
        width: "100%",
        height: "100%",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        position: "absolute",
        zIndex: -1,
        objectFit: "cover",
        backgroundColor: "black",
        pointerEvents: "none"
      }}
        poster={state.mobileView ? bg_image : bg_image}
        preload="metadata"
        muted defaultMuted autoPlay playsInline loop oncontextmenu="return false;" onEnded={() => setAnimationDone(true)}>
        <source src={state.mobileView ? ampvidMobile : bg_image} type="video/mp4"></source>
      </video>
      <div
        style={{
          zIndex: 0,
          position: "absolute",
          pointerEvents: "none",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.0) 0%, #000 95%)",
        }}
      ></div>
      {/* 
      <Box sx={{
        position: "absolute",
        fontSize: 50,
        color: "white",
        href: "#ampBanner",
        variant: "outlined",
        bottom: { xs: 160, md: 80 },
        left: 0,
        right: 0,
        mr: "auto",
        ml: "auto",

      }}
      >
        <IconButton
          href="#ampBanner"
          sx={{
            color: "white",
          }}
        >
          <ExpandMoreIcon sx={{ fontSize: 50 }} />
        </IconButton>
      </Box> */}

      <Grid container justifyContent={"center"} className={animationDone ? "fadeIn" : "fadeOut"}>
        <Grid xs={12} md={10} sx={{ background: "none", p: 1, borderRadius: 10, }}>
          <Image />
          {/* <Box sx={{ minHeight: "100vh" }} /> */}
          <Typography
            variant="h2"
            fontSize={30}
            sx={{ fontSize: 30, }}
          >
            ToneSuite - Distant
          </Typography>
          <Typography
            // fontFamily={"pirulen"}
            style={{
              fontSize: state.mobileView ? "20px" : "30px",
              // fontWeight: 500,
            }}
          >
            <i>Energy. Intensity. Brutality.</i>
          </Typography>

          <PriceComponent product={product} hideVAT />
          <Box sx={{ mt: 3, columnGap: 5, rowGap: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "center", alignItems: "center" }}>
            <Button
              sx={{ width: { xs: "75%", md: "150px", background: "rgba(36, 36, 36, 0.5)" } }}
              variant="outlined"
              onClick={() => {
                const element = document.getElementById("overview");
                if (element) {
                  let y = element?.getBoundingClientRect()?.top + window.pageYOffset - 64;
                  window.scrollTo({ top: y, behavior: 'smooth' });
                }
              }}
            >
              Learn More
            </Button>
            <Button
              variant="outlined"
              onClick={onTrial}
              sx={{ width: { xs: "75%", md: "150px", background: "rgba(36, 36, 36, 0.5)" } }}
            >
              Free Trial
            </Button>
            <BuyButton color="primary" variant="contained" product={product} sx={{ width: { xs: "75%", md: "150px" } }} />
          </Box>
        </Grid>
      </Grid>
    </Box >
  );
};

export default MainBanner;
